import React from 'react';
import {Form, Input} from 'semantic-ui-react';

const FormVehicleWaitHappy = ({detail, agency = false}) => {
  const {
    car,
    orderNo,
    lineNo,
    katashiki,
    sfx,
    chassis,
    motor,
    color,
  } = detail;

  return (
    <React.Fragment>
      {!agency && (
        <Form.Group widths='three'>
          <Form.Field
            control={Input}
            label='Número de orden'
            defaultValue={orderNo || ''}
            placeholder='Número de orden'
          />
          <Form.Field
            control={Input}
            label='Número de línea'
            defaultValue={lineNo || ''}
            placeholder='Número de línea'
          />
          <Form.Field
            control={Input}
            label='Katashiki'
            value={`${sfx} - ${katashiki}`}
            placeholder='Katashiki'
          />
        </Form.Group>
      )}
      <Form.Group widths='three'>
        <Form.Field
          control={Input}
          label='Modelo'
          defaultValue={car || ''}
          placeholder='Modelo'
        />
        <Form.Field
          control={Input}
          label='Color'
          defaultValue={color || ''}
          placeholder='color'
        />
        <Form.Field
          control={Input}
          label='Chasis'
          defaultValue={chassis || ''}
          placeholder='Chasis'
        />
      </Form.Group>
      {!agency && (
        <Form.Group widths='three'>
          <Form.Field
            control={Input}
            label='Motor'
            defaultValue={motor || ''}
            placeholder='Motor'
          />
        </Form.Group>
      )}
    </React.Fragment>
  );
};

export default FormVehicleWaitHappy;
